<template>
  <div v-wechat-title="informationBaseTitle" class="informationList">
    <!-- 公共头部 -->
    <com-header :message="message"></com-header>

    <!-- content -->
    <div class="informationList_content">
      <div class="breadcrumb-cont">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="informationListGuid === 'news_lib'">
            产业动态
          </el-breadcrumb-item>
          <el-breadcrumb-item v-else>
            关于我们
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="infoList">
        <!-- 左侧科目 -->
        <div class="infoContent_left fl">
          <ul>
            <li
              v-for="(item, index) in subject"
              :key="index"
              :class="{ active: chooseLiNum == index }"
              @click="columncheck(item.pccGuid, index, item.pccName)"
            >
              <h2 class="title_size" v-text="item.pccName"></h2>
            </li>
          </ul>
        </div>
        <!-- 右侧列表 -->
        <div v-if="infoContentList" class="infoContent_right fl">
          <div v-if="defaultShow === '暂无数据'" class="nodata">
            {{ defaultShow }}
          </div>
          <ul v-if="defaultShow != '暂无数据'" class="ul">
            <li
              v-for="(item, index) in infoList"
              :key="index"
              v-loading="aboutUsContentLoading"
              @click="enterDetails(item)"
            >
              <div class="imgWarp">
                <img
                  v-if="item.newImgHref === 'empty' || item.newImgHref == ''"
                  src="../../assets/images/baseDefaultIMG.png"
                />
                <img
                  v-if="item.newImgHref != 'empty' && item.newImgHref != ''"
                  :src="item.newImgHref"
                />
              </div>
              <div class="infoRinght_source">
                <h1 class="title_size" v-text="item.newsName"></h1>
                <div class="ellipsis">
                  <div>
                    {{ handleOverflow(item.notes) }}
                  </div>
                  <span class="ellipsis-after"> ... </span>
                </div>
                <div class="news-info">
                  <span
                    v-if="item.newsFrom != ''"
                    class="margin_r trans_one"
                    v-text="item.newsFrom"
                  ></span>
                  <span class="trans_one" v-text="item.editTime"></span>
                  <span></span>
                </div>
              </div>
            </li>
          </ul>
          <!-- 分页器 -->
          <div v-if="pagingShow" class="infoContent_paging">
            <el-pagination
              background
              layout="prev, pager, next,total,jumper,sizes"
              :total="totalNewsNums"
              :current-page="currentPageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSizeActive"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              @prev-click="handlePrevPage"
              @next-click="handleNextPage"
            ></el-pagination>
          </div>
        </div>
        <!-- 关于我们右侧content  -->
        <div v-else-if="!infoContentList" class="aboutUs_right fl">
          <section v-if="aboutUsContent != '暂无数据'">
            <img
              v-if="informationListGuid !== 'about_lib'"
              :src="columuTitleImg"
            />
          </section>
          <div
            v-loading="aboutUsContentLoading"
            :class="aboutUsContent === '暂无数据' ? 'nodata' : ''"
            class="padding40"
            v-html="aboutUsContent"
          >
            {{ aboutUsContent }}
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <com-footer v-if="footShow"></com-footer>
  </div>
</template>
<script>
// 引入防抖方法
import { _debounce } from '../../util/public'
import NProgress from 'nprogress'
export default {
  data() {
    return {
      linkSource: '',
      informationBaseTitle: '',
      message: '',
      // 是否显示默认图片
      isDefaultImg: false,
      // 显示关于我们/新闻列表
      infoContentList: true,
      // aboutUsTitle: '企业简介',
      aboutUsContent: '',
      // 分页器单页隐藏
      pagingShow: false,
      // 左侧科目列表
      subject: [],
      // 右侧咨询列表
      infoList: [],
      currentPageNum: 1,
      // 当前页面类目 资讯or新闻
      informationListGuid: 'news_lib',
      // 分页配置
      totalNewsNums: 1000, // 总条数
      // 栏目选中高亮色
      chooseLiNum: 'init',
      // 栏目guid
      columnGuid: '',
      // 总条数小于每页条数时分页器隐藏
      pageSizeActive: 10,
      footShow: false,
      // 关于我们栏目title图片
      columuTitleImg: '',
      // 暂无数据
      defaultShow: '',
      aboutUsContentLoading: true
    }
  },
  watch: {
    $route() {
      // 判断当前是资讯or新闻列表or关于我们
      this.informationListGuid = this.$route.query.informationListGuid
      if (this.informationListGuid === 'news_lib') {
        this.message = '行业资讯'
        this.informationBaseTitle = '智筑通 - 产业动态'
      } else if (this.informationListGuid === 'hotnews_lib') {
        this.message = '需求发布'
        this.informationBaseTitle = '智筑通 - 需求发布'
      } else if (this.informationListGuid === 'about_lib') {
        this.message = '关于我们'
        this.informationBaseTitle = '智筑通 - 关于我们'
      }
      // 查询当前栏目列表
      this.informationList()
    }
  },
  created() {
    // 判断当前是资讯or新闻列表or关于我们
    this.informationListGuid = this.$route.query.informationListGuid
    if (this.informationListGuid === 'news_lib') {
      this.message = '行业资讯'
      this.informationBaseTitle = '智筑通 - 产业动态'
    } else if (this.informationListGuid === 'hotnews_lib') {
      this.message = '需求发布'
      this.informationBaseTitle = '智筑通 - 需求发布'
    } else if (this.informationListGuid === 'about_lib') {
      this.message = '关于我们'
      this.informationBaseTitle = '智筑通 - 关于我们'
    }
    // 查询当前栏目列表
    this.informationList()
  },
  methods: {
    // 超出
    handleOverflow(str) {
      if (str && str !== 'null' && typeof str !== 'undefined') {
        str = str.replace(/<[^<>]+>/g, '')
        // 去掉转义字符
        str = str.replace(/&nbsp;/g, '')
        return str
      }
    },
    // pageSize每页条数改变时会触发
    handleSizeChange(val) {
      this.pageSizeActive = val
      this.searchList(this.columnGuid, this.chooseLiNum, 1)
    },
    // currentPage 当前页改变时会触发
    handleCurrentChange(val) {
      this.searchList(this.columnGuid, this.chooseLiNum, val)
    },
    // 点击prev时触发
    handlePrevPage(val) {
      this.searchList(this.columnGuid, this.chooseLiNum, val)
    },
    // 点击next时触发
    handleNextPage(val) {
      this.searchList(this.columnGuid, this.chooseLiNum, val)
    },
    // 栏目点击事件
    columncheck: _debounce(function(pccGuid, index, name) {
      this.aboutUsContentLoading = true
      this.searchList(pccGuid, index, 1, 10)
    }, 200),
    // 行业资讯栏目列表
    async informationList() {
      // 查询频道下所有栏目
      let { data } = await this.$http.get(
        '/cms/ptChannelsColumn/' + `${this.informationListGuid}`
      )
      this.subject = data
      // 默认显示第一条栏目下的资讯/新闻
      this.searchList(data[0].pccGuid, 0, 1)
    },
    // 点击栏目切换资讯/新闻列表
    async searchList(pccGuid, index, page, isColumn) {
      // 判断当前是显示关于我们还是新闻类
      if (this.informationListGuid === 'about_lib') {
        this.infoContentList = false
        // 查询栏目单页面
        let pcGuid = 'about_lib'
        this.$http
          .get(
            '/cms/ptChannelsColumn/findByPccGuidSingle/' +
              `${pcGuid}/${pccGuid}`
          )
          .then(res => {
            if (res.data.ptChannelsColumn.pccIcon.includes('http')) {
              this.columuTitleImg = res.data.ptChannelsColumn.pccIcon
            }
            if (
              res.data.ptNews.notes !== '' &&
              res.data.ptNews.notes !== undefined
            ) {
              this.aboutUsContent = res.data.ptNews.notes
            } else {
              this.aboutUsContent = '暂无数据'
            }
            this.aboutUsContentLoading = false
          })
          .catch(err => {
            // 如果请求失败,弹出警告框
            if (err) {
              NProgress.done()
              this.aboutUsContent = '暂无数据'
            }
          })
      } else {
        this.infoContentList = true
        //  后台默认从第0页开始
        let choosePage = page - 1
        if (isColumn !== '' && isColumn !== undefined && isColumn !== null) {
          this.pageSizeActive = isColumn
        }
        // 根据栏目Id查询新闻列表/资讯列表
        let { data } = await this.$http.get(
          '/cms/ptNews/findByPccGuidOrderByEditTimeDesc/' +
            `${pccGuid}/${choosePage}/${this.pageSizeActive}`
        )
        if (data.content.length > 0) {
          for (let i = 0; i < data.content.length; i++) {
            data.content[i].newImgHref = data.content[i].newsIcon
          }
          // 新闻列表赋值
          this.infoList = data.content
          this.aboutUsContentLoading = false
          // 总条数
          this.totalNewsNums = data.totalElements
          if (data.totalPages <= 1) {
            this.pagingShow = false
          } else {
            this.pagingShow = true
          }
          this.defaultShow = ''
        } else {
          this.defaultShow = '暂无数据'
          this.pagingShow = false
        }
      }
      this.footShow = true
      // 栏目高亮色修改
      this.chooseLiNum = index
      this.columnGuid = pccGuid
    },
    // 进入资讯/新闻详情页
    enterDetails(item) {
      if (item.newsUrl !== '') {
        window.open(item.newsUrl, '_blank')
      } else {
        this.$router.push({
          name: 'informationDetails',
          query: {
            nszxID: item.id,
            category: this.informationListGuid
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scope>
@import './InformationBase.scss';
</style>

<style lang="scss">
.breadcrumb-cont {
  .el-breadcrumb__item:hover {
    .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      color: #d11d26;
    }
  }
}
</style>
